import {dropzoneExists, fnErrorMsg} from "./jquery-functions-library";
import {element_exists} from "./functions";
import * as Dropzone from "dropzone";

export var uploadProfilePicture = function () {

    var formName = '#form-upload-profile-picture';
    var modal = '#modal-upload-profile-picture';
    var gotNewProfilePicture = false;

    if (!element_exists(formName)) {
        return false;
    }

    if (!dropzoneExists($('#form-upload-profile-picture'))) {

        var uploadUrl = '/user/profile-picture/upload';
        var deleteUrl = '/user/profile-picture/delete';

        Dropzone.autoDiscover = false;

        var lang = allLangFiles.dropzone;

        $('#form-upload-profile-picture').dropzone({

            dictDefaultMessage: lang.dictDefaultMessage,
            dictFallbackMessage: lang.dictFallbackMessage,
            dictFallbackText: lang.dictFallbackText,
            dictFileTooBig: lang.dictFileTooBig,
            dictInvalidFileType: lang.dictInvalidFileType,
            dictResponseError: lang.dictResponseError,
            dictCancelUpload: lang.dictCancelUpload,
            dictCancelUploadConfirmation: lang.dictCancelUploadConfirmation,
            dictRemoveFile: lang.dictRemoveFile,
            dictMaxFilesExceeded: lang.dictMaxFilesExceeded,

            url: uploadUrl,
            parallelUploads: 1,
            addRemoveLinks: true,
            maxFiles: 1,

            init: function () {

                var myDropzone = this;

                /**
                 * TODO LOOOOOOOOOOP.........
                 * Show file from server
                 * https://github.com/enyo/dropzone/wiki/FAQ#how-to-show-files-already-stored-on-server
                 */
                $.ajax({
                    url: '/user/profile-picture/get',
                    success: function (response) {

                        if (response.data !== undefined) {
                            myDropzone.removeEventListeners();

                            /*Deleting and trying to upload creates a looop...............*/

                            var mockFile = {
                                name: response.data.filename,
                                size: response.data.size,
                                dataURL: '/profile-pictures/profiles/' + response.data.filename,
                                status: 'mockFile'
                            };


                            // Call the default addedfile event handler
                            myDropzone.emit("addedfile", mockFile);

                            myDropzone.files.push(mockFile);

                            myDropzone.createThumbnailFromUrl(mockFile, myDropzone.options.thumbnailWidth, myDropzone.options.thumbnailHeight,
                                myDropzone.options.thumbnailMethod, true, function (thumbnail) {
                                    myDropzone.emit('thumbnail', mockFile, thumbnail);
                                });


                            // Make sure that there is no progress bar, etc...
                            myDropzone.emit("complete", mockFile);


                            // If you use the maxFiles option, make sure you adjust it to the
                            // correct amount:
                            var existingFileCount = 1; // The number of files already uploaded
                            myDropzone.options.maxFiles = myDropzone.options.maxFiles - existingFileCount;
                        }
                    },
                    error: fnErrorMsg
                });

                this.on('maxfilesreached', function () {
                    myDropzone.removeEventListeners();
                    gotNewProfilePicture = true;

                    console.log('max');
                });

                this.on("removedfile", function (file) {

                    console.log('removed');

                    myDropzone.setupEventListeners();

                    myDropzone.options.maxFiles = 1;

                    $.ajaxSetup({headers: {'X-CSRF-TOKEN': $('[name="_token"]').val()}});

                    $.ajax({
                        type: 'POST',
                        url: deleteUrl,
                        data: '',
                        success: function (data) {
                            console.log(data);

                        },
                        error: fnErrorMsg
                    });
                });
            },
        });

        $(modal).off('hidden.bs.modal').on('hidden.bs.modal', function () {
            if (gotNewProfilePicture) window.location.reload();
        });
    }
};